import { GetToDosQuery } from '@/gql/graphql';
import {
  Antrag,
  AntragZeitstempel,
} from '../../components/Table/ToDoTable/entities/Antrag';
import { Zeitstempel } from '../../components/Table/ToDoTable/entities/Zeitstempel';
import dayjs from 'dayjs';

type ToDo = GetToDosQuery['toDos'][number];
type ToDoAntraege = Extract<ToDo, { __typename?: 'ToDoAntraege' }>;

function isToDoAntrag(toDo: ToDo): toDo is ToDoAntraege {
  return toDo.__typename === 'ToDoAntraege';
}

export function getToDoAntraege({ data }: { data: GetToDosQuery }) {
  const toDoAntraege = data.toDos
    .filter(isToDoAntrag)
    // oxlint-disable-next-line complexity
    .map((toDoAntrag) => {
      const newToDoAntrag = new Antrag({
        id: toDoAntrag.antragId ?? '',
        beginn: toDoAntrag.antragBeginn
          ? new AntragZeitstempel({
              zeitstempel: new Zeitstempel({
                abweichung: 0,
                zeitpunkt: toDoAntrag.antragBeginn.zeitstempel.zeitpunkt
                  ? dayjs(toDoAntrag.antragBeginn.zeitstempel.zeitpunkt)
                  : undefined,
              }),
              changeRequested: toDoAntrag.antragBeginn.changeRequested,
            })
          : undefined,
        ende: toDoAntrag.antragEnde
          ? new AntragZeitstempel({
              zeitstempel: new Zeitstempel({
                abweichung: 0,
                zeitpunkt: toDoAntrag.antragEnde.zeitstempel.zeitpunkt
                  ? dayjs(toDoAntrag.antragEnde.zeitstempel.zeitpunkt)
                  : undefined,
              }),
              changeRequested: toDoAntrag.antragEnde.changeRequested,
            })
          : undefined,
        mitarbeiter: {
          id: toDoAntrag.mitarbeiter.id,
          vorname: toDoAntrag.mitarbeiter.vorname,
          nachname: toDoAntrag.mitarbeiter.nachname,
          imgUrl: toDoAntrag.mitarbeiter.bildUrl ?? undefined,
          arbeitsbereich: {
            id: toDoAntrag.antragArbeitsbereich.id,
            name: toDoAntrag.antragArbeitsbereich.name,
            markierung: toDoAntrag.antragArbeitsbereich.markierung,
          },
          extern: toDoAntrag.mitarbeiter.extern,
        },
        arbeitsbereich: {
          id: toDoAntrag.antragArbeitsbereich.id,
          name: toDoAntrag.antragArbeitsbereich.name,
          markierung: toDoAntrag.antragArbeitsbereich.markierung,
          abteilungen: (toDoAntrag.antragArbeitsbereich.abteilungen ?? []).map(
            (abteilung) => {
              return {
                id: abteilung.id,
              };
            },
          ),
        },
        status: toDoAntrag.status ?? undefined,
        offen: toDoAntrag.offen ?? undefined,
        bemerkungAntragsteller: toDoAntrag.bemerkungAntragsteller ?? undefined,
        bemerkungVorgesetzter: toDoAntrag.bemerkungVorgesetzter ?? undefined,
        datum: toDoAntrag.datum ?? undefined,
        arbeitszeitId: toDoAntrag.arbeitszeitId ?? undefined,
        erstellungsdatum: toDoAntrag.erstellungsdatum ?? undefined,
        aenderungsdatum: toDoAntrag.aenderungsdatum ?? undefined,
      });
      return newToDoAntrag;
    });

  return toDoAntraege;
}
